import { DOMAttributes, SVGAttributes } from './constants';
const DataRegex = /data-([a-zA-Z0-9\-]*)/;
const AriaRegex = /aria-([a-zA-Z0-9\-]*)/;
/**
 * Cleans the given SVG properties object by removing any properties that are not valid or in the list of exclusions.
 *
 * @param {object} props - The SVG properties object to be cleaned.
 * @param {string[]} excludes - An array of property names to be excluded from cleaning.
 * @param {string[]} [customAttributes=[]] - The list of custom attribute names to include.
 * @returns {object} - The cleaned SVG properties object.
 */
export const cleanSVGProps = (props = {}, excludes = [], customAttributes = []) => {
    const returnProps = Object.assign({}, props);
    const validProps = Object.keys(returnProps).filter((key) => {
        if (excludes.indexOf(key) !== -1) {
            return false;
        }
        if (customAttributes.indexOf(key) > -1) {
            return true;
        }
        if (DataRegex.test(key)) {
            return true;
        }
        if (AriaRegex.test(key)) {
            return true;
        }
        return SVGAttributes.indexOf(key) !== -1 || DOMAttributes.indexOf(key) !== -1;
    });
    Object.keys(returnProps).forEach((key) => {
        if (validProps.indexOf(key) === -1) {
            delete returnProps[key];
        }
    });
    return returnProps;
};
